<template>
    <div id="HomeTabsContent">
        <Banner v-if="activeTabName==='banner'"/>
        <Celebrities v-else-if="activeTabName==='celebrities'"/>
        <Feeds v-else-if="activeTabName==='feeds'"/>
        <Outstanding v-else-if="activeTabName==='outstanding'"/>
        <Categories v-else-if="activeTabName==='categories'"/>
        <Webstars v-else-if="activeTabName==='webstars'"/>
    </div>
</template>
<script>
import Banner from "../Sections/Banner.vue";
import Celebrities from "../Sections/Celebrities.vue";
import Feeds from "../Sections/Feeds.vue";
import Outstanding from "../Sections/Outstanding.vue";
import Categories from "../Sections/Categories.vue";
import Webstars from "../Sections/Webstars.vue";

export default {
    name: 'HomeTabsContent',
    components: {
        Banner,
        Celebrities,
        Outstanding,
        Feeds,
        Categories,
        Webstars,
    },
    props: {
        activeTabName: {
            type: String,
            default: null
        }
    }
}
</script>
